export default [
  { title: 'DECOIT', to: 'https://decoit.de/de/home.html' },
  { title: 'AGB', to: '/Agb' },
  { title: 'Impressum', to: '/Impressum' },
  { title: 'Datenschutz', to: '/Datenschutz' },
];
